import script from "./CoffeeTaxonomyExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./CoffeeTaxonomyExplorer.vue?vue&type=script&setup=true&lang=js"

import "./CoffeeTaxonomyExplorer.vue?vue&type=style&index=0&id=6290060e&scoped=true&lang=css"
script.__scopeId = "data-v-6290060e"

export default script